import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MedicalRecordVisitReasonModel
} from "../../../../../../../modules/medical/medical-record/visit-reason/api/model/medicalRecordVisitReason.model";
import {ConsultationPainItemComponent} from "../consultation-pain-item/consultation-pain-item.component";
import {
  DateSummaryFieldModule
} from "../../../../../../../modules/core/component/date/date-summary-field/date-summary-field.module";
import {ItemModule} from "../../../../../../../modules/core/component/item/item.module";
import {
  LovValueSummaryFieldModule
} from "../../../../../../../modules/common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module";
import {SummaryFieldModule} from "../../../../../../../modules/core/component/summary-field/summary-field.module";
import {TablerIconsProvider} from "angular-tabler-icons";
import {IconPencil, IconDotsCircleHorizontal, IconTrash, IconArrowBack} from "angular-tabler-icons/icons";
import {ButtonComponent} from "../../../../core/components/api/button/button.component";
import {DialogController} from "../../../../../../../modules/common/dialog/dialogController";
import {
  MedicalRecordVisitReasonCreateUpdatePage,
  MedicalRecordVisitReasonSaveDialogInput, MedicalRecordVisitReasonSaveDialogResult
} from "../../../../../../../modules/medical/medical-record/visit-reason/impl/page/medical-record-visit-reason-create-update/medical-record-visit-reason-create-update.page";
import {
  MedicalRecordVisitReasonCreateUpdatePageModule
} from "../../../../../../../modules/medical/medical-record/visit-reason/impl/page/medical-record-visit-reason-create-update/medical-record-visit-reason-create-update.module";
import {
  MedicalRecordVisitReasonDeleteService
} from "../../../../../../../modules/medical/medical-record/visit-reason/impl/service/medicalRecordVisitReasonDelete.service";
import {SummaryModule} from "../../../../../../../modules/core/component/summary/summary.module";
import {IconsModule} from "../../../../../../../../icons.module";
import {ConsultationProblemItemComponent} from "../consultation-problem-item/consultation-problem-item.component";
import {DateLabelModule} from "../../../../../../../modules/core/component/date/date-label/date-label.module";

@Component({
  selector: 'app-luna-consultation-visit-reason-item',
  standalone: true,
  imports: [CommonModule, ConsultationPainItemComponent, DateSummaryFieldModule, ItemModule, LovValueSummaryFieldModule, SummaryFieldModule, ButtonComponent, MedicalRecordVisitReasonCreateUpdatePageModule, SummaryModule, IconsModule, ConsultationProblemItemComponent, DateLabelModule],
  templateUrl: './consultation-visit-reason-item.component.html',
  providers: [
   MedicalRecordVisitReasonDeleteService
  ],
})
export class ConsultationVisitReasonItemComponent {

  @Input() visitReason: MedicalRecordVisitReasonModel;
  @Input() titleDisplay: 'title' | 'date' = 'date';

  constructor(private dialogController: DialogController,
              public deleteService: MedicalRecordVisitReasonDeleteService) {

  }

  edit() {
    const input: MedicalRecordVisitReasonSaveDialogInput = {
      id: this.visitReason.id,
    };
    this.dialogController.open(
        MedicalRecordVisitReasonCreateUpdatePage,
        input, {
          title: 'Motif de consultation',
          width: '95%'
        }).afterClosed()
        .toPromise()
        .then((value: MedicalRecordVisitReasonSaveDialogResult) => {
          if (value) {
            this.visitReason = value.entity;
          }
    });
  }
}
